

<div class="widget-container" #treeChartDiv>
  <!-- Headings -->
  <main >
    <article #fs fullscreen-able [class.is-active]="isActive" style="background: white;">
      <div class="mb-3">
        <icon-chart 
          [headerConfig]="item.config?.widget_header_config"
          [data]="chartData" 
          [pageKey]="pageKey" 
          [heading]="heading"
          [chartName]="'treeChartDiv'" 
          [config]="treeMapchart" 
          [expand]="fs" 
          [fullscreen]="isFullscreen"
          [item]="item"
          [chartType]="chartType"
          [excelConfig]="excelConfig"
          [apiKey]="this.item?.config?.['list_group_of_api']?.api_key"
          (chartTypeEmitter)="chartTypeEmitter($event)"
          (showBySubs)="showBySubs($event)"
        ></icon-chart>
      </div>

      <!-- Chart -->
      <div *ngIf="loader">
        <loading> </loading>
      </div> 

      <div *ngIf="noData" style="height: 300px; width: auto;">
        <span class="bg-text" >{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>
        
      <div #treeMapchart [style.display]="noData ? 'none':'block'" class="pb-2">
        <app-tree-map-chart 
          [chartData]="chartData"
          [chartType]="chartType"
          [dynamicCol]="dynamicCol"
           [item]="item"
           [pageKey]="pageKey"
          [colorPalette]="colorPalette"
          (detailTrigger)="detailTrigger($event)"
          (singleClicked)="singleClicked($event)"
        ></app-tree-map-chart>
      </div>
    </article>
  </main>
</div>

